import type { ArtifactVersionDto } from '@inference.engine/api-client';
import { inferenceHttp } from '@/lib/api/http-client';

export const saveAudienceSessionAsArtifact = async (
  contextId: string,
  workspaceId: string,
): Promise<string> => {
  const response = await inferenceHttp.post({
    url: `/api/v1/audience-sessions/${contextId}/artifact`,
    query: { workspaceId },
  });

  const data = response.data as ArtifactVersionDto;
  if (!data.id) {
    throw new Error('Failed to save audience session as artifact');
  }
  return data.id;
};
